import React, { useCallback, useEffect, useState } from "react";
import { Col, Modal, Row, Table } from "react-bootstrap";
import TablePagination from "./TablePagination";
import { ValidateFields } from "./validate/ValidateFields";
import ErrorFilter from "../helper/errorFilter";
import { errorResponse } from "../helper/error";
import { toast } from "react-toastify";
import { getServerURL } from "../helper/envConfig";
import { Link } from "react-router-dom";
import api from "../helper/api";
import SingleError from "../helper/SingleError";
const requireField = ["videoUrl"];

const VideoCategoryTable = ({ temp, addVideoCategory, categoryList, setId, updateVideoCategory, getVideoCategory, deleteVideoCategory, setDeleteModel, deleteModel, category, setCategory, setEditModel, editModel }) => {
    const serverURL = getServerURL();
    const editModelOpenFun = () => {
        setErrors({});
        setSubmitCount(0)
        setEditModel(true)
    };
    const editModelCloseFun = () => setEditModel(false);
    const deleteModelOpenFun = () => setDeleteModel(true);
    const deleteModelCloseFun = () => setDeleteModel(false);
    const [deleteVideoID, setDeleteVideoID] = useState("");
    const [page, setPage] = useState(1);
    const [limit] = useState(10);
    const [videoList, setVideoList] = useState([]);
    const [paginationData, setPaginationData] = useState({});
    const [editVideoCategory, setEditVideoCategory] = useState({});

    const [submitCount, setSubmitCount] = useState(0);
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});

    // useEffect(() => {
    //   getVideoLinkList();
    // }, []);

    // const getVideoLinkList = useCallback(() => {
    //     try {
    //         api
    //             .postWithToken(
    //                 `${serverURL}video-playlist-manage?page=${page}&limit=${limit}`,
    //                 { action: "list" }
    //             )
    //             .then(async (res) => {
    //                 if (res?.data?.success === true) {
    //                     setVideoList(res?.data?.data);
    //                     setPaginationData(res?.data?.pagination);
    //                 }
    //             })
    //             .catch((e) => {
    //                 if (
    //                     e?.response?.status === 404 ||
    //                     e?.response?.statusText === "Not Found"
    //                 ) {
    //                     setVideoList([])
    //                 }
    //             });
    //     } catch (error) {
    //         console.log('error: ', error);
    //     }
    // }, [page, limit, serverURL]);

    useEffect(() => {
        // getVideoCategory();
    }, [page]);

    return (
        <>
            <Col className="ctmTable">
                <Table bordered responsive className="text-center">
                    <thead className="tableHeader">
                        <tr>
                            <th className="number-width border">No</th>
                            <th>Video Category</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody className="tableBody ">
                        {categoryList?.data.length ? (
                            categoryList?.data?.map((item, index) => (
                                <tr key={item?._id}>
                                    <td>{(page - 1) * limit + index + 1}</td>
                                    <td className="w-50 fullTextShow text-start px-5">{item?.category || ""}</td>
                                    <td>
                                        <div className="d-flex justify-content-center align-items-center gap-1">
                                            <button
                                                className="border-0 bg-transparent"
                                                onClick={() => {
                                                    editModelOpenFun();
                                                    setEditVideoCategory(item);
                                                    setId(item?._id);
                                                    setCategory(item.category);
                                                }}
                                            >
                                                <img src="/images/svg/edit.svg" title="Edit" alt="edit" />
                                            </button>
                                            <button
                                                className="border-0 bg-transparent"
                                                onClick={(e) => {
                                                    deleteModelOpenFun(item?._id);
                                                    setDeleteVideoID(item?._id);
                                                    setId(item?._id);
                                                }}
                                            >
                                                <img src="/images/svg/delete.svg" title="Delete" alt="delete" />
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="3" className="text-center p-5">
                                    No Data Found.
                                </td>
                            </tr>
                        )}
                    </tbody>

                </Table>
                {/* <div className="d-md-flex justify-content-end align-items-center">
                    {Boolean(videoList?.length) && paginationData?.totalPages > 1 && (
                        <TablePagination
                            currentPage={paginationData?.currentPage}
                            totalPages={paginationData?.totalPages}
                            onPageChange={(newPage) => {
                                setPage(newPage);
                            }}
                        />
                    )}
                </div> */}
            </Col>

            {/* Edit user modal */}
            <Modal
                size="lg"
                show={editModel}
                onHide={editModelCloseFun}
                centered
                className="modal-main info-modal"
            >
                <Modal.Header
                    className="d-block position-relative border-0 pt-4 px-4"
                    closeButton
                >
                    <Modal.Title className="text-center">Edit Video Category</Modal.Title>
                    <div className="d-flex justify-content-center text-center mt-2">
                        <img src="/images/svg/line.svg" className="mt-2" alt="line" />
                    </div>
                </Modal.Header>
                <Modal.Body className="mx-md-4 border-0 bg-transparent pt-0 ctmInput">
                    <Row>
                        <Col md={12}>
                            <label id="videoUrl">Video Category<span className="star">*</span></label>
                            <textarea
                                rows={3}
                                className="form-control px-3"
                                placeholder="Please enter Video category here"
                                type="text"
                                name="videoUrl"
                                value={category || ""}
                                onChange={(e) => setCategory(e.target.value)}
                            />
                        </Col>
                    </Row>
                    <div className="d-flex justify-content-center">
                        <button className=" btn-login bg-main text-uppercase border-0 w-75 my-4"
                            onClick={() => { updateVideoCategory() }}>
                            Save
                        </button>
                    </div>
                </Modal.Body>
            </Modal>

            {/* Delete user modal */}
            <Modal
                size="md"
                show={deleteModel}
                onHide={deleteModelCloseFun}
                centered
                className="modal-main info-modal"
            >
                <Modal.Header
                    className="d-block position-relative border-0 pt-4 px-4"
                    closeButton
                >
                    <Modal.Title className="text-center">Delete Video Category</Modal.Title>
                    <div className="d-flex justify-content-center text-center mt-2">
                        <img src="/images/svg/line.svg" alt="line" />
                    </div>
                </Modal.Header>
                <Modal.Body className="mx-4 border-0">
                    <p className="fs-28 fw-500">Are you sure you want to delete?</p>
                </Modal.Body>
                <Modal.Footer className="border-0">
                    <div className="d-flex m-auto gap-3 pb-3 px-4">
                        {/* <button
              className="modalCancelBtn px-5 border-0"
              onClick={() => deleteModelCloseFun}
            >
              Cancel
            </button> */}
                        <button className="modalDeleteBtn border-0" disabled={loading} onClick={() => deleteVideoCategory()}>Delete</button>
                    </div>
                </Modal.Footer>
            </Modal>

        </>
    );
};

export default VideoCategoryTable;
